import { frontendURL } from '../../../../helper/URLHelper';

const crm = accountId => ({
  parentNav: 'crm',
  routes: ['crm', 'crm_dashboard', 'funnel'],
  menuItems: [
    {
      icon: 'crm-inner',
      label: 'CRM',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/crm`),
      toStateName: 'crm',
    },
    {
      icon: 'arrow-trending-lines',
      label: 'CRM_DASHBOARD',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/crm/dashboard`),
      toStateName: 'crm_dashboard',
    },
  ],
});

export default crm;
